import { useRouteLoaderData } from "@remix-run/react";
import type { loader as rootLoader } from "~/root";

export function useCurrentUser() {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  return useRouteLoaderData<typeof rootLoader>("root")!.user;
}
